export default __webpack_public_path__ + "static/media/pic1.d53b1b76.png";